export function objectMap<T extends object>(
  object: T,
  callbackFn: (value: unknown, key: string) => unknown,
) {
  return Object.fromEntries(
    Object.entries(object).map(([key, value]) => [key, callbackFn(value, key)]),
  )
}
